import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

// Bouton "copier" avec retour visuel, partage par la page d'invitation (adresse
// du compte) et le bloc d'installation (adresse de l'app sur ordinateur).
//
// L'ecriture dans le presse-papier demande un contexte securise : en HTTP, ou si
// l'utilisateur l'a refusee, l'appel echoue. Le texte reste selectionnable a
// cote, donc on se contente de ne pas afficher le "Copied".

const ACCENT = '#f97316';

const CopyButton = ({ value, label = 'Copy', copiedLabel = 'Copied', onCopy, sx }) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 2000);
      onCopy?.();
    } catch {
      // presse-papier indisponible : le texte reste lisible et selectionnable
    }
  }, [value, onCopy]);

  return (
    <Button
      onClick={copy}
      startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
      sx={{
        textTransform: 'none',
        fontSize: '0.9rem',
        fontWeight: 600,
        color: copied ? '#4ade80' : ACCENT,
        minWidth: 0,
        px: 1,
        // Cible tactile de 44 px minimum (spec v5, Lisibilite) : ce bouton vit
        // sur les surfaces du parcours d'invitation, lues a bout de bras.
        py: 1.25,
        flexShrink: 0,
        '&:hover': { backgroundColor: 'rgba(249,115,22,0.08)' },
        ...sx,
      }}
    >
      {copied ? copiedLabel : label}
    </Button>
  );
};

export default CopyButton;
